import { Button, InputError } from '@foodsby/nutrient'
import React from 'react'
import { Field } from 'redux-form'
import { acceptance, confirmation, length, required } from 'redux-form-validators/lib'

import { termsAndConditionsRoute } from '../../routes/routes'
import Checkbox from '../common/reduxForms/Checkbox'
import Input from '../common/reduxForms/Input'
import { Submitting } from '../common/Submitting'

const ConfirmRegisterForm = ({ confirmPasswordError, handleSubmit, submitting }) => (
  <form onSubmit={handleSubmit}>
    <div className="row center-xs">
      <div className="col-xs">
        <h2 className="title">Just one more step to complete</h2>
        <p className="description">{`Let's set up your new password`}</p>
      </div>
    </div>
    <div className="col-xs-12 _lr-hide">
      <Field
        component={Input}
        id="password"
        label="Password *"
        name="password"
        type="password"
        validate={[required({ msg: `Password is required` }), length({ min: 8 })]}
      />
    </div>
    <div className="col-xs-12 _lr-hide">
      <Field
        component={Input}
        id="ConfirmPassword"
        label="Confirm Password *"
        name="verifyPassword"
        type="password"
        validate={[
          required({ msg: `Confirm Password is required` }),
          confirmation({ field: 'password', fieldLabel: 'password' }),
        ]}
      />
    </div>
    <div className="col-xs-12">
      <Field
        component={Checkbox}
        id="AgreeToTOS"
        label={
          <span>
            By signing up, you agree to our{' '}
            <a href={termsAndConditionsRoute.path} rel="noopener noreferrer" target="_blank">
              Terms and Conditions Agreement
            </a>
          </span>
        }
        name="agreeToTOS"
        validate={[
          acceptance({
            msg: `You must accept the Terms and Conditions Agreement`,
          }),
        ]}
      />
    </div>
    <div className="row col-xs-12 center-xs" style={{ marginTop: '16px' }}>
      {submitting ? <Submitting /> : <Button type="submit">Submit</Button>}
      {confirmPasswordError && (
        <InputError visible={confirmPasswordError && confirmPasswordError !== null}>
          {confirmPasswordError}
        </InputError>
      )}
    </div>
  </form>
)
export default ConfirmRegisterForm
